import { userAreaNavSelector } from '../layout/left-nav/root.left-nav.js';

function getNavHeight() {
  return document.querySelector(userAreaNavSelector)?.scrollHeight ?? 0;
}

export { getNavHeight };
//# sourceMappingURL=getNavHeight.js.map
